/**
 * Event name constants for big brother analytics.
 * The list is provided by Analytics Team.
*/

export const BIG_BROTHER_EVENTS = {
    jobsApplyInit : 'JobApply_init',
    jobsApplySuccess : 'JobApply_success',
    jobsPostAdInit : 'Post_Ad_init',
    jobsPostAdSuccess : 'Post_Ad_success',
    jobsSnBFilterSelect : 'Filter_select',
    jobsVapLoad : 'VAP',
    jobsHomeLoad : 'CATHOME',
    jobsSnbSearch : 'Search',
    jobsSnbBrowse : 'Browse',
    jobsCallInit : 'Call_init',
    jobsCallSuccess : 'Call_success'
};



// WEBPACK FOOTER //
// ../q-jobs/src/utils/BigBrotherAnalytics/constants.js